export const getConfig = () => {
  if (process.env.PLATFORM === 'olimp') {
    return {
      ...require('./variables/olimp').default,
      ...require('./olimp.js').default,
    }
  } else if (process.env.PLATFORM === 'olymp') {
    return {
      ...require('./variables/olymp').default,
      ...require('./olymp.js').default,
    }
  }
}
